import React, { useState, useEffect, useRef } from 'react';
import * as allIcons from 'ionicons/icons';

const IconSelect = ({ value, onChange, className = '' }) => {
  const [icons, setIcons] = useState([]);
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    // Get all icon names from the package
    const iconNames = Object.keys(allIcons).map(key => {
      // Convert camelCase to kebab-case and remove 'Outline', 'Sharp' suffixes
      return key
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .toLowerCase()
        .replace(/-outline$|-sharp$/, '');
    });
    
    // Remove duplicates and sort
    const uniqueIcons = [...new Set(iconNames)].sort();
    setIcons(uniqueIcons);

    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredIcons = icons.filter(icon =>
    icon.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (icon) => {
    onChange(icon);
    setIsOpen(false);
    setSearch('');
  };

  return (
    <div className={`position-relative ${className}`} ref={dropdownRef}>
      <div 
        className="form-control d-flex align-items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        {value ? (
          <>
            <ion-icon name={value} className="me-2"></ion-icon>
            <span>{value}</span>
          </>
        ) : (
          <span className="text-muted">Select an icon</span>
        )}
      </div>

      {isOpen && (
        <div className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm" style={{ zIndex: 1000 }}>
          <div className="p-2 border-bottom">
            <div className="position-relative">
              <input
                type="text"
                placeholder="Search icons..."
                className="form-control border-0"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
              <ion-icon 
                name="search" 
                className="position-absolute"
                style={{ left: '10px', top: '50%', transform: 'translateY(-50%)' }}
              ></ion-icon>
              {search && (
                <button
                  onClick={() => setSearch('')}
                  className="btn btn-link position-absolute p-0"
                  style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}
                >
                  <ion-icon name="close"></ion-icon>
                </button>
              )}
            </div>
          </div>
          
          <div className="small text-muted px-2">
            {filteredIcons.length} icons found
          </div>

          <div 
            className="p-2"
            style={{ 
              maxHeight: '250px',
              overflowY: 'auto'
            }}
          >
            {filteredIcons.map(icon => (
              <div
                key={icon}
                className="d-flex align-items-center p-2 cursor-pointer hover-bg-light"
                onClick={() => handleSelect(icon)}
              >
                <ion-icon name={icon} className="me-2"></ion-icon>
                <span className="small">{icon}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default IconSelect;